<template>
  <nav>
    <ul class="level-1">
      <li @click="toggle">
        <a class="open">
          <i class="icon-trophy"></i>
          <span>Финансы</span>
          <b></b>
        </a>
        <ul class="level-2">
          <li>
            <router-link :to="{ name: 'finance_my' }">Мои финансы</router-link>
          </li>
          <li v-if="admin">
            <router-link :to="{ name: 'finance_payroll' }"
              >Начисления</router-link
            >
          </li>
          <li v-if="admin">
            <router-link :to="{ name: 'finance_payout' }"
              >Выдача зп</router-link
            >
          </li>
          <li v-if="adminOrLeader">
            <router-link :to="{ name: 'finance_stats' }"
              >Статистика</router-link
            >
          </li>
        </ul>
      </li>
      <li>
        <router-link :to="{ name: 'base_knowledge' }">
          <i class="icon-layers"></i>
          <span>База знаний</span>
        </router-link>
        <ul class="level-2" v-if="admin">
          <li>
            <router-link :to="{ name: 'base_settings' }">Настройки</router-link>
          </li>
        </ul>
      </li>
      <li v-if="admin">
        <router-link :to="{ name: 'users_list' }">
          <i class="icon-profile-male"></i>
          <span>Пользователи</span>
        </router-link>
      </li>
      <li v-if="admin">
        <router-link :to="{ name: 'settings_overview' }">
          <i class="icon-gears"></i>
          <span>Настройки</span>
        </router-link>
      </li>
    </ul>
    <div class="user-nav-m">
      <router-link :to="{ name: 'profile_overview' }">
        <img v-if="image" @error="$avatarError" :src="$IMAGE(image)" />
        <span>{{ first_name }}</span>
      </router-link>
      <a @click="userLogout">Выход</a>
    </div>
  </nav>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("user", {
      image: state => state.data.image,
      first_name: state => state.data.first_name,
      admin: state => state.data.admin,
      role: state => state.data.role
    }),
    adminOrLeader() {
      return !!this.admin || (this.role && this.role.includes(4)); // leader
    }
  },
  methods: {
    ...mapActions("app", ["setSettings", "setLoading"]),
    ...mapActions("user", ["logout"]),
    userLogout() {
      this.setLoading(true);
      this.logout();
    },
    toggle(ev) {
      try {
        const localName = ev.target.localName;
        const target = localName !== "a" ? ev.target.parentNode : ev.target;

        const ul = target.nextElementSibling;
        if (target.classList.contains("open")) {
          target.classList.remove("open");
          ul.style.height = 0;
        } else {
          target.classList.add("open");
          ul.style.height = `${40 * ul.childElementCount}px`;
        }
      } catch (e) {
        void e;
      }
    }
  }
};
</script>
